/**
 * V-Model of Form-Renderer
 */
import {CONTROLS} from "../../configs/controls";
import { evaluateRule } from "../../libraries/rule-evaluator";

const EMIT_EVENT = "change";

const MODEL = {
    props: {
        value: Object,
    },
    model: {
        event: EMIT_EVENT,
        props: "value"
    },
    data: () => ({
        valueContainer: null
    ,
        visibleMap: {}
    }),
    watch: {
        value: {
            deep: true,
            handler(val) {
                if (typeof val !== 'object') {
                    return
                }

                // set value for fields
                Object.assign(this.valueContainer, val)
            }
        },

        valueContainer: {
            deep: true,
            handler(val) {
                if (!val) return;

                this.$emit(EMIT_EVENT, this.valueContainer)

                // Re-evaluate visibility rules when values change
                if (typeof this.evaluateAllVisibility === 'function') {
                    this.evaluateAllVisibility()
                }
            },
        }
    },
    methods: {
        evaluateAllVisibility() {
            try {
                const vc = this.valueContainer || {}
                const visibility = {}

                // Controls
                Object.keys(this.formData.controls || {}).forEach(controlId => {
                    const control = this.formData.controls[controlId]
                    const key = control.name && control.name !== '' ? control.name : control.uniqueId

                    if (control.visibilityRules && Array.isArray(control.visibilityRules) && control.visibilityRules.length) {
                        // support multiple rules as array -> evaluate AND of rules
                        const ok = control.visibilityRules.every(r => evaluateRule(r, vc))
                        visibility[key] = !!ok
                    } else {
                        visibility[key] = true
                    }
                })

                // Sections
                Object.keys(this.formData.sections || {}).forEach(sectionId => {
                    const section = this.formData.sections[sectionId]
                    const key = section.uniqueId
                    if (section.visibilityRules && Array.isArray(section.visibilityRules) && section.visibilityRules.length) {
                        const ok = section.visibilityRules.every(r => evaluateRule(r, vc))
                        visibility[key] = !!ok
                    } else {
                        visibility[key] = true
                    }
                })

                this.$set(this, 'visibleMap', visibility)
            } catch (e) {
                // silent fail
                console.error('evaluateAllVisibility error', e)
            }
        },
        /**
         * Create Value Container to Store the Data
         */
        createValueContainer() {
            let containerObj = {}
            const controlIds = Object.keys(this.formData.controls)

            controlIds.forEach(controlId => {
                const controlItem = this.formData.controls[controlId]

                // Skip if control type is not registered (prevents crash on unknown control types)
                if (!controlItem || !controlItem.type || !CONTROLS[controlItem.type]) {
                    console.warn(`[createValueContainer] Unknown control type "${controlItem?.type}" for control "${controlId}" - skipping`)
                    return
                }

                // if disableValue is provided, we don't need to solve more for the control
                if (
                    typeof CONTROLS[controlItem.type].disableValue === 'boolean' &&
                    CONTROLS[controlItem.type].disableValue
                ) {
                    return
                }

                // get the key-name value
                let name = controlItem.name;
                if (!name) {
                    // fall-back to id if no name
                    name = controlId;
                }

                // add new empty field value
                containerObj[name] = ""

                // if the control has default factory creation closure, run it
                if (typeof CONTROLS[controlItem.type].rendererDefaultData === 'function') {
                    containerObj[name] = CONTROLS[controlItem.type].rendererDefaultData(controlItem)
                }
            });

            // emit to the parent for the value detail
            if (this.value) {
                this.$emit(EMIT_EVENT, containerObj)
            }

            // set to the real handler
            this.valueContainer = containerObj

            // initial visibility evaluation
            if (typeof this.evaluateAllVisibility === 'function') {
                this.evaluateAllVisibility()
            }
        }
    },

    created() {
        this.createValueContainer()
    },
}

export {
    MODEL
}